import { render, staticRenderFns } from "./header-with-navigation-below.vue?vue&type=template&id=afa386a6&scoped=true&"
import script from "./header-with-navigation-below.vue?vue&type=script&lang=js&"
export * from "./header-with-navigation-below.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=afa386a6&scoped=true&lang=css&"
import style1 from "./header-with-navigation-below.vue?vue&type=style&index=1&id=afa386a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa386a6",
  null
  
)

export default component.exports